import {initTelInput} from './pajr.forms.js'

/**
 * Quick Form Table Widget
 */
Charcoal.Admin.Widget_Quick_Form_Table = function (opts)
{
    Charcoal.Admin.Widget_Table.call(this, opts);

    // Widget_Quick_Form_Table properties
    this.create_title      = '';
    this.edit_title        = '';
    this.form_ident        = '';
    this.quick_form_widget_type = 'charcoal/admin/widget/paj/forms/quick-form';
    this.storable_property = null;
    this.storable_value    = null;
    this.storable_data     = null;
    this.show_object_actions = null;
};

Charcoal.Admin.Widget_Quick_Form_Table.prototype = Object.create(Charcoal.Admin.Widget_Table.prototype);
Charcoal.Admin.Widget_Quick_Form_Table.prototype.constructor = Charcoal.Admin.Widget_Quick_Form_Table;
Charcoal.Admin.Widget_Quick_Form_Table.prototype.parent = Charcoal.Admin.Widget_Table.prototype;

Charcoal.Admin.Widget_Quick_Form_Table.prototype.set_properties = function ()
{
    Charcoal.Admin.Widget_Table.prototype.set_properties.call(this);

    var opts = this.opts();

    this.create_title      = opts.data.create_title || tableWidgetL10n.quickCreate;
    this.edit_title        = opts.data.edit_title || tableWidgetL10n.quickEdit;
    this.form_ident        = opts.data.form_ident || this.form_ident;
    this.quick_form_widget_type = opts.data.quick_form_widget_type || this.quick_form_widget_type;
    this.storable_value    = opts.data.storable_value || this.storable_value;
    this.storable_property = opts.data.storable_property || this.storable_property;
    this.storable_data     = opts.data.storable_data || this.storable_data;
    this.agent_value       = opts.data.agent_value || this.agent_value;
    this.agent_property    = opts.data.agent_property || this.agent_property;
    this.mrc_value         = opts.data.mrc_value || this.mrc_value;
    this.mrc_property      = opts.data.mrc_property || this.mrc_property;
    this.show_object_actions = opts.data.show_object_actions || this.show_object_actions;
    return this;
};

Charcoal.Admin.Widget_Quick_Form_Table.prototype.widget_options = function () {
    return Object.assign(Charcoal.Admin.Widget_Table.prototype.widget_options.call(this), {
        show_object_actions: this.show_object_actions,
        storable_data: this.storable_data,
        storable_property: this.storable_property,
        agent_property: this.agent_property,
        mrc_property: this.mrc_property,
        create_title: this.create_title,
        edit_title: this.edit_title,
        form_ident: this.form_ident,
        quick_form_ident: this.form_ident,
    });
};

Charcoal.Admin.Widget_Quick_Form_Table.prototype.bind_events = function ()
{
    // Prevent multiple binds
    $('.js-jump-page-form', this.table_selector).off('submit');
    $('.js-page-switch', this.table_selector).off('click');

    this.element()
        .off('click')

    Charcoal.Admin.Widget_Table.prototype.bind_events.call(this);

    var that = this;

    this.element()
        .on('click', '.js-obj-edit', function (event) {
            var href = new URL(this.href);
            var objId = href.searchParams.get('obj_id');

            if (objId !== null) {
                event.preventDefault();

                var formIdent = href.searchParams.get('form_ident');
                var widgetOptions = {};
                if (formIdent !== null) {
                    formIdent = formIdent.replace('/edit/', '/quick/');
                    widgetOptions = {
                        form_ident: formIdent
                    };
                }

                that.open_quick_form(objId, {
                    title: that.edit_title,
                    widget_options: widgetOptions
                }, function (response) {
                    if (response.success) {
                        that.reload(null, true);
                    }
                });
            }
        })
        .on('click', '[class*="js-list-create"]', function (event) {
            event.preventDefault();

            var url = new URL(this.href);
            var formIdent = url.searchParams.get('form_ident');
            var widgetOptions = {};
            if (formIdent !== null) {
                formIdent = formIdent.replace('/create/', '/quick/');
                widgetOptions = {
                    form_ident: formIdent
                };
            }

            for (let [key, value] of Object.entries($(this).data())) {
                if (key !== 'form_data') continue
                widgetOptions['form_data'] = value
            }

            that.open_quick_form(null, {
                title: that.create_title,
                widget_options: widgetOptions
            }, function (response) {
                if (response.success) {
                    that.reload(null, true);
                }
            });
        })
        .on('click', '[class*="js-quick-delete"],[class*="js-obj-delete"]', function (event) {
            event.preventDefault();
            that.delete_object($(this).closest('tr'));
        });

    return this;
}

Charcoal.Admin.Widget_Quick_Form_Table.prototype.open_quick_form = function (objId, customOpts, callback)
{
    var that = this;

    const isEditing = objId !== null;

    if (!isEditing) {
        objId = 0;
    }

    if (!customOpts) {
        customOpts = {};
    }

    var defaultOpts = {
        size:           BootstrapDialog.SIZE_WIDE,
        cssClass:       '-quick-form',
        widget_type:    this.quick_form_widget_type,
        widget_options: {
            obj_id:     objId,
            obj_type:   customOpts?.widget_options?.form_data?.obj_type ?? this.obj_type,
            form_ident: this.form_ident,
            form_data:  {},
        }
    };

    // When editing an object, we don't need to pass the form_data. The model already has its needed context.
    if (!isEditing) {
        if (this.storable_value !== null && this.storable_property !== null) {
            defaultOpts.widget_options.form_data[this.storable_property] = this.storable_value;
        }

        if (this.storable_data !== null && typeof this.storable_data === 'object' && Object.keys(this.storable_data).length > 0) {
            Object.keys(this.storable_data).forEach(function (key) {
                defaultOpts.widget_options.form_data[key] = that.storable_data[key];
            })
        }
    }

    if (this.agent_value !== null && this.agent_property !== null && defaultOpts.widget_options.obj_id === 0) {
        defaultOpts.widget_options.form_data[this.agent_property] = this.agent_value;
    }

    if (this.mrc_value !== null && this.mrc_property !== null && defaultOpts.widget_options.obj_id === 0) {
        defaultOpts.widget_options.form_data[this.mrc_property] = this.mrc_value;
    }

    var immutableOpts = {};
    var dialogOpts = $.extend(true, {}, defaultOpts, customOpts, immutableOpts);

    var dialog = this.dialog(dialogOpts, function (response) {
        if (response.success) {
            // Call the quickForm widget js.
            // Really not a good place to do that.
            if (!response.widget_id) {
                return false;
            }

            Charcoal.Admin.manager().add_widget({
                id:   response.widget_id,
                type: 'charcoal/admin/widget/quick-form',
                data: {
                    obj_type: dialogOpts?.widget_options?.form_data?.obj_type ?? that.obj_type
                },
                obj_id: objId,
                save_callback: function (response) {
                    callback(response);
                    dialog.close();
                }
            });

            // Init all tel inputs in quick form
            $('#'+ response.widget_id).find('input[type="tel"]').each((index, ele) => initTelInput(ele))

            // Trigger for the "Voir l'utilisateur" url update
            if ($('.js-user-selectize', '#'+response.widget_id).length) {
                $('.js-user-selectize', '#'+response.widget_id).on('change', window.onChangeUserSelectize);
                $('.js-user-selectize', '#'+response.widget_id).trigger('change');
            }

            // Trigger for the Change region exploratory stay quick custom creation
            if ($('.js-exploratory-region', '#'+response.widget_id).length) {
                $('.js-exploratory-region', '#'+response.widget_id).on('change', window.onChangeExploratoryRegion);
                $('.js-exploratory-region', '#'+response.widget_id).trigger('change');
            }

            // Trigger for the Change region exploratory stay quick custom creation
            if ($('select.js-exploratory-collaborator', '#'+response.widget_id).length) {
                $('select.js-exploratory-collaborator', '#'+response.widget_id).on('change', window.onChangeExploratoryCollaborator);
                $('select.js-exploratory-collaborator', '#'+response.widget_id).trigger('change');
            }

            // Re render.
            // This is not good.
            Charcoal.Admin.manager().render();
        }
    });
};

/**
 * Handle the "delete" button / action.
 */
Charcoal.Admin.Widget_Quick_Form_Table.prototype.delete_object = function (row) {
    var that       = this;
    BootstrapDialog.confirm({
        title:      formWidgetL10n.confirmDeletion,
        type:       BootstrapDialog.TYPE_DANGER,
        message:    $('<p>' + commonL10n.confirmAction + '</p><p class="mb-0">' + commonL10n.cantUndo + '</p>'),
        btnOKLabel: commonL10n.delete,
        callback:   function (result) {
            if (result) {
                var url  = Charcoal.Admin.admin_url() + 'object/delete';
                var data = {
                    obj_type: that.obj_type,
                    obj_id:   row.attr('data-id')
                };
                $.ajax({
                    method:   'POST',
                    url:      url,
                    data:     data,
                    dataType: 'json'
                }).done(function (response) {
                    if (response.success) {
                        that.reload(null, true);
                    } else {
                        window.alert(formWidgetL10n.deleteFailed);
                    }
                }).fail(function (response) {
                    var feedback;
                    var response = response.responseJSON;

                    // Get first feedback
                    if (response && response.feedbacks && response.feedbacks.length) {
                        feedback = response.feedbacks.shift();
                    }

                    feedback = feedback || {};

                    if (typeof feedback.message != 'undefined') {
                        BootstrapDialog.show({
                            title:    'Échec de la suppression',
                            message:  feedback.message,
                            type:     BootstrapDialog.TYPE_DANGER,
                            onhidden: null
                        });
                    }
                });
            }
        }
    });
};
